module.exports = __webpack_public_path__ + "static/media/Google-Authenticator-icon.65aec51e.png";